import { Skeleton, Typography } from "@mui/material"
import Stack from '@mui/material/Stack';

export const ListSkeleton = () => {
    return(<Stack spacing={1}>
        <Typography variant="h1"><Skeleton variant="text" sx={{bgcolor: '#e1e1e1'}} width={400}/></Typography>
        <Skeleton variant="rectangular" height={650} sx={{fontSize: '2rem', bgcolor: '#e1e1e1'}} />
    </Stack>)
}